import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=1c051dd8&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=ts"
export * from "./EditContact.vue?vue&type=script&lang=ts"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=1c051dd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c051dd8",
  null
  
)

export default component.exports